import React, { useEffect, useState } from "react";
import SectionHead from "../SectionHead";
import Slider from "react-slick";
import CategoryBox from "./CategoryBox";
import Wrapper from "../../helpers/Wrapper";
import { useCategory } from "../../hooks/useCategory";

function Categories() {


  const [categories, setCategories] = useState([])

  const { data, isPending } = useCategory()

  useEffect(() => { setCategories(data || []) }, [data])

  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 4,
    initialSlide: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 3,
          infinite: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div className="w-full relative">
      <Wrapper>
        <SectionHead
          title="Browse our Categories"
          description="Explore a wide range of products through our diverse categories. "
        />

        {/* Cats */}

        <div className="mt-8 slider-container overflow-hidden">
          <Slider {...settings} className="center">
            {categories && categories?.length && categories?.map((category, i) => (
              <div className="w-32" key={i}>
                <CategoryBox data={category} loading={isPending} />
              </div>
            ))}
          </Slider>
        </div>
      </Wrapper>
    </div>
  );
}

export default Categories;
